import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { PDFMarginComponent as BaseComponent } from '@progress/kendo-angular-pdf-export';
var PDFMarginComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PDFMarginComponent, _super);
    function PDFMarginComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFMarginComponent.decorators = [
        { type: Component, args: [{
                    selector: 'kendo-grid-pdf-margin',
                    template: ''
                },] },
    ];
    /** @nocollapse */
    PDFMarginComponent.ctorParameters = function () { return []; };
    return PDFMarginComponent;
}(BaseComponent));
export { PDFMarginComponent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/pdf/pdf-margin.component.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/pdf/pdf-margin.component.js
// module chunks = vendor